import { render, staticRenderFns } from "./find-job-card.vue?vue&type=template&id=54b1210f&scoped=true&"
import script from "./find-job-card.vue?vue&type=script&lang=js&"
export * from "./find-job-card.vue?vue&type=script&lang=js&"
import style0 from "./find-job-card.vue?vue&type=style&index=0&id=54b1210f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b1210f",
  null
  
)

export default component.exports